import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { CancelAutoRenewTrialModalMobileProps } from './CancelAutoRenewTrialModalMobile.types';

export const renderCancelSubscriptionTrialMobile = (data: CancelAutoRenewTrialModalMobileProps) =>
    openPopupHelper({ popupName: popupNames.SUBSCRIPTION_CANCEL_TRIAL_MOBILE, data });
